<template>
  <div class="website">
    <!-- 导航 -->
    <header class="navbar">
      <div class="logo">野雨 ♥ 个人摄影服务</div>
<!--      ●▪-->
      <nav class="menu">
        <span>首页</span>
        <span>服务项目</span>
        <span>作品展示</span>
        <span>预约联系</span>
      </nav>
    </header>

    <!-- 封面大图（你喜欢的高级封面） -->
    <section class="hero">
      <div class="inner">
        <h1>一站式摄影服务</h1>
        <p>预设售卖 | 修图合成 | 同城约拍 | 服装租赁</p>
        <button class="btn" @click="toService">立即查看</button>
      </div>
    </section>

    <!-- 四大服务 -->
    <section class="services" ref="serviceRef">
      <h2>服务项目</h2>
      <div class="grid">
        <div class="card">
          <h3>LR预设售卖</h3>
          <p>古风 / 人像 / 电影感 / 日系</p>
          <button @click="goToPresetStore">前往预设商店</button>
        </div>
        <div class="card">
          <h3>专业修图 / 大合成</h3>
          <p>精修、调色、商业合成、换景、质感提升</p>
        </div>
        <div class="card">
          <h3>同城约拍</h3>
          <p>个人写真 / 电影感 / 古风 / 创作拍摄</p>
          <button @click="goToPhotoDetail">了解约拍详情</button>
        </div>
        <div class="card">
          <h3>服装租赁</h3>
          <p>古风、Lolita摄影主题服装出租</p>
        </div>
      </div>
    </section>

    <!-- 作品 -->
    <section class="works">
      <h2>作品展示</h2>
      <div class="grid">
<!--        <img v-for="i in 8" :key="i" :src="`https://picsum.photos/600/800?${i}`" />-->
        <img v-for="i in 10" :key="i" :src="'/showphotos/' + i + '.jpg'" />
<!--        <img-->
<!--            v-for="(img, index) in photoList"-->
<!--            :key="index"-->
<!--            :src="img"-->
<!--        />-->
      </div>
    </section>

    <!-- 对比 -->
    <section class="compare">
      <h2>修图对比</h2>
      <div class="row">
        <div><img src="https://picsum.photos/600/800?before"></div>
        <div><img src="https://picsum.photos/600/800?after"></div>
      </div>
    </section>

    <!-- 预约表单（发你邮箱） -->
    <section class="contact">
      <h2>预约咨询</h2>
      <form action="https://formspree.io/f/xxxx" method="POST">
        <input type="text" name="name" placeholder="姓名" required />
        <input type="text" name="wechat" placeholder="微信" required />
        <select name="service">
          <option>咨询修图</option>
          <option>咨询约拍</option>
          <option>咨询服装租赁</option>
          <option>购买预设</option>
        </select>
        <button type="submit">提交预约</button>
      </form>
    </section>

    <footer>
      <p>© 2025 个人摄影服务 | 微信：yeyu20001105</p>
    </footer>
  </div>
</template>

<script setup>
import { ref } from 'vue'
const serviceRef = ref(null)
import { useRouter } from 'vue-router'
// import hefu from '@/assets/hefu.jpg'
// import zhanguo from '@/assets/zhanguo.png'
// import wuxia1 from '@/assets/wuxai1.jpg'
// import wuxia2 from '@/assets/wuxia2.jpg'
// import shinv from '@/assets/shinv.jpg'
// import lolita from '@/assets/lolita.jpg'
// import jianghu from '@/assets/jianghu.jpg'
// import zhanguo2 from '@/assets/zhanguo2.png'
const router = useRouter()

// const photoList  = ['/src/assets/hefu.jpg','/src/assets/zhanguo.jpg','/src/assets/wuxia1.jpg']
//
// const photoList = [hefu, zhanguo, wuxia2, shinv, lolita, jianghu,zhanguo2]
// const imageList = [
//   '/src/assets/myphotos/1.jpg',
//   '/src/assets/myphotos/2.jpg',
//   '/src/assets/myphotos/3.jpg',
//   '/src/assets/myphotos/4.jpg',
//   '/src/assets/myphotos/5.jpg',
//   '/src/assets/myphotos/6.jpg',
// ]

const toService = () => {
  serviceRef.value?.scrollIntoView({ behavior: 'smooth' })
}

const goToPresetStore = () => {
  // alert("后续可跳转到你的预设商店链接")
  router.push('/preset-shop')
  // window.location.href = "你的预设商店网址"
}

const goToPhotoDetail = () => {
  // alert("后续可跳转到约拍详情页面")
  router.push('/photo-detail')
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}
.navbar {
  display: flex;
  justify-content: space-between;
  padding: 22px 6vw;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 99;
}
.logo { font-size: 18px; font-weight: 600; }
.menu { display: flex; gap: 24px; color: #444; }
.hero {
  height: 80vh;
  background: linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.7)),
  /*url("https://picsum.photos/1920/1080?random=10");*/
  url("/src/assets/wuxia2.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-align: center;
}
.hero h1 { font-size: 44px; margin-bottom: 14px; }
.hero p { font-size: 17px; opacity: 0.9; margin-bottom: 30px; }
.btn {
  padding: 16px 36px;
  border-radius: 50px;
  border: none;
  font-size: 15px;
  cursor: pointer;
}
.services { padding: 70px 6vw; background: #fafafa; }
.services h2 {
  font-size: 28px;
  text-align: center;
  margin-bottom: 40px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 26px;
}
.card {
  background: #fff;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 4px 14px rgba(0,0,0,0.05);
}
.card h3 { margin-bottom: 10px; }
.card p { color: #666; margin-bottom: 16px; }
.card button {
  padding: 10px 16px;
  background: #111;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
.works { padding: 70px 6vw; }
.works h2 {
  font-size: 28px;
  text-align: center;
  margin-bottom: 40px;
}
.works img {
  width: 100%;
  height: 380px;
  object-fit: cover;
  border-radius: 12px;
}
.compare { padding: 70px 6vw; background: #fafafa; }
.compare h2 {
  font-size: 28px;
  text-align: center;
  margin-bottom: 30px;
}
.row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
.row img { width: 100%; border-radius: 12px; }
.contact { padding: 70px 6vw; }
.contact h2 {
  font-size: 28px;
  text-align: center;
  margin-bottom: 30px;
}
form {
  max-width: 550px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
input, select {
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 15px;
}
form button {
  padding: 17px;
  background: #111;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
}
footer {
  background: #111;
  color: #eee;
  text-align: center;
  padding: 30px 0;
  font-size: 14px;
}
</style>
